import * as ShopifyBuy from '@shopify/buy-button-js';

const shopifyOptions = (onlineStore) => {
  return {
    product: {
      iframe: false,
      buttonDestination: onlineStore ? "onlineStore": "modal",
      styles: {
        product: {
          "@media (min-width: 601px)": {
            "max-width": "calc(25% - 20px)",
            "margin-left": "20px",
            "margin-bottom": "50px",
          },
        },
        button: {
          "visibility": "hidden",
        },
      },
      contents: {
        img: false,
        title: false,
        price: false,
        unitPrice: true,
        options: true,
        quantity: false,
        quantityInput: true,
      },
    },
    cart: {
      contents: {
        button: true,
      },
      styles: {
        button: {
          "background-color": "#1a1a1a",
          ":hover": {
            "background-color": "#2c2c2c",
          },
          ":focus": {
            "background-color": "#2c2c2c",
          }
        },
        footer: {
          "background-color": "#ffffff",
        },
      },
    },
    toggle: {
      iframe: false,
      contents: {
        count: false,
        icon: false,
        title: false,
      },
      text : {
        title: ""
      },
      styles: {
        toggle: {
          "display": "none",
        },
      },
    },
    modalProduct: {
      styles: {
        hasImage: {
          "img": {
            "max-height": "500px",
          }
        },
      },
    },
    modal: {
      styles: {
        img: {
          "max-height": "90vh",
        },
      },
    },
  };
}

let client, ui;

export const openCart = () => ui.openCart();

export const init = async ({domain, token, productIds, onlineStore}) => {
  client = await ShopifyBuy.buildClient({
    domain: domain,
    storefrontAccessToken: token,
  });

  ui = ShopifyBuy.UI.init(client);
  
  productIds.forEach(productId => {
    ui.createComponent('product', {
      id: productId,
      node: document.getElementById(`product-component-${productId}`),
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: shopifyOptions(onlineStore),
    });
  });
  
  return ShopifyBuy.UI.init(client);
};
